import React from 'react'
import "./Map.css"

const Map = () => {
  return (
    <a
      className="addres-map"
      href="https://www.google.com/maps?q=1ST+FLOOR,+MOTILAL+OSWAL+FINANCIAL+SERVICES+LIMITED,+SCO-45,+near+HDFC+BANK,+DLF+COLONY,+Tripuri,+Patiala,+Punjab+147004"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Open Profi1 Station location in Google Maps"
    >
      <iframe
        title="Profi1 Station Office Location"
        src="https://www.google.com/maps?q=1ST+FLOOR,+MOTILAL+OSWAL+FINANCIAL+SERVICES+LIMITED,+SCO-45,+near+HDFC+BANK,+DLF+COLONY,+Tripuri,+Patiala,+Punjab+147004&output=embed"
        width="100%"
        height="100%"
        style={{ border: 0, pointerEvents: "none" }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </a>
  )
}

export default Map